export const getIosAppTrackingStatus = async (): Promise<null | string> => null;
